import { render, staticRenderFns } from "./ImageProduct.vue?vue&type=template&id=11068a16"
import script from "./ImageProduct.vue?vue&type=script&lang=js"
export * from "./ImageProduct.vue?vue&type=script&lang=js"
import style0 from "./ImageProduct.vue?vue&type=style&index=0&id=11068a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports